const FORMULA_PREFIXES = new Set(['=', '+', '-', '@', '\t', '\r', '\n']);

/**
 * Strips the one-character export marker (`'`) that product/asset CSV export
 * adds in front of a formula-prefix character. Does not strip a leading `=`
 * itself — only `'` + formula prefix.
 */
export default function denormalizeCsvCell(value) {
  if (typeof value !== 'string') return value;
  if (value.charAt(0) === "'" && FORMULA_PREFIXES.has(value.charAt(1))) {
    return value.slice(1);
  }
  return value;
}
